import { onlyDigits } from "@plataforma/shared";

const pad = (value: number) => String(value).padStart(2, "0");
const atNoon = (date: string) => new Date(`${date}T12:00:00`);
export const toIso = (date: Date) => `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;

export const todayIso = () => toIso(new Date());
export function addDays(date: string, days: number): string {
  const value = atNoon(date);
  value.setDate(value.getDate() + days);
  return toIso(value);
}
/** Segunda a domingo da semana que contém a data. */
export function weekDates(date: string): string[] {
  const monday = addDays(date, -((atNoon(date).getDay() + 6) % 7));
  return Array.from({ length: 7 }, (_, index) => addDays(monday, index));
}
export function monthStart(monthsBack = 0, from = new Date()): string {
  return toIso(new Date(from.getFullYear(), from.getMonth() - monthsBack, 1, 12));
}
export function monthEnd(from = new Date()): string {
  return toIso(new Date(from.getFullYear(), from.getMonth() + 1, 0, 12));
}

/** Formatadores no idioma e na moeda da aplicação (vêm da configuração, não do código). */
export function createFormatters(locale: string, currency: string) {
  const money = new Intl.NumberFormat(locale, { style: "currency", currency });
  const short = new Intl.DateTimeFormat(locale, { day: "2-digit", month: "2-digit", year: "numeric" });
  const long = new Intl.DateTimeFormat(locale, { weekday: "long", day: "numeric", month: "long" });
  const dayMonth = new Intl.DateTimeFormat(locale, { day: "numeric", month: "short" });
  const weekday = new Intl.DateTimeFormat(locale, { weekday: "short" });
  const month = new Intl.DateTimeFormat(locale, { month: "short", year: "numeric" });
  return {
    money: (value: number) => money.format(value),
    date: (date: string) => short.format(atNoon(date)),
    longDate: (date: string) => long.format(atNoon(date)),
    dayMonth: (date: string) => dayMonth.format(atNoon(date)),
    weekday: (date: string) => weekday.format(atNoon(date)).replace(".", ""),
    month: (key: string) => month.format(atNoon(`${key}-01`)),
  };
}
export type Formatters = ReturnType<typeof createFormatters>;

export function whatsappUrl(phone: string, text?: string): string {
  const digits = onlyDigits(phone);
  return `https://wa.me/${digits.startsWith("55") && digits.length > 11 ? digits : `55${digits}`}${text ? `?text=${encodeURIComponent(text)}` : ""}`;
}

export const initials = (name: string) => name.split(/\s+/).slice(0, 2).map((part) => part[0] ?? "").join("").toUpperCase();
